import { render, staticRenderFns } from "./PlayerProfileLink.vue?vue&type=template&id=5317e962&scoped=true&"
import script from "./PlayerProfileLink.vue?vue&type=script&lang=js&"
export * from "./PlayerProfileLink.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProfileLink.vue?vue&type=style&index=0&id=5317e962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317e962",
  null
  
)

export default component.exports